const translations = {
  "en": {
    "Alpha Picks": "Alpha Picks",
    "Claim 500 Credits": "Claim 500 Credits",
    "Earnings Plays": "Earnings Plays",
    "How about 500 Credits on us?": "How about 500 Credits on us?",
    "IPO Strategies": "IPO Strategies",
    "Sector Scanner": "Sector Scanner",
    "Still want to cancel": "Still want to cancel"
  },
  "zh-tw": {
    "Alpha Picks": "Alpha 精選",
    "Claim 500 Credits": "領取 500 點數",
    "Earnings Plays": "財報交易策略",
    "How about 500 Credits on us?": "送你 500 點數如何？",
    "IPO Strategies": "IPO 策略",
    "Sector Scanner": "產業掃描器",
    "Still want to cancel": "仍要取消嗎"
  }
};

export default translations;
